import { render, staticRenderFns } from "./TextCard.vue?vue&type=template&id=14fedae8&scoped=true&"
import script from "./TextCard.vue?vue&type=script&lang=js&"
export * from "./TextCard.vue?vue&type=script&lang=js&"
import style0 from "./TextCard.vue?vue&type=style&index=0&id=14fedae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fedae8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
